import { z } from "zod";

export const addUpiSchema = z.object({
    upiId: z.string().min(1, 'UPI ID is required'),
    privacyPolicy: z.boolean().refine(value => value === true, {
      message: 'You must agree to the privacy policy',
    }),
});

export const addBankSchema = z.object({
  ifscCode: z.string().min(11, 'IFSC code must be 11 characters'),
  accountNumber: z.string().regex(/^\d{9,18}$/, { message: 'Account number must be 9-18 digits' }),
  confirmAccountNumber: z.string().min(1, 'Please confirm account number'),
  accountHolderName: z.string().min(1, 'Account holder name is required'),
  acceptTerms: z.boolean().refine(value => value === true, {
    message: 'You must agree to the privacy policy',
  }),
}).refine(data => data.accountNumber === data.confirmAccountNumber, {
  message: 'Account numbers don\'t match',
  path: ['confirmAccountNumber'],
});